import apiDtMood from './dtMoodApiHandler'

const getDenunciationCategories = () => {
  return new Promise((resolve, reject) => {
    apiDtMood
      .get(`/denunciation-categories`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const getDenunciationSubcategories = (categoryId) => {
  return new Promise((resolve, reject) => {
    apiDtMood
      .get(`/denunciation-subcategories?categoryId=${categoryId}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const sendBadbehavior = (data) => {
  return new Promise((resolve, reject) => {
    apiDtMood
      .post(`/denunciations`, data)
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export { getDenunciationCategories, getDenunciationSubcategories, sendBadbehavior }
